import { useEffect, useState } from "react";

import {
  type KeystoneOfferEligibility,
  type OfferStatusCode,
} from "data/keystone-api-mapping";
import {
  useKeystone,
  usePolicyDetail,
  usePolicyOffers,
} from "data/ss-data-hooks";
import { logException, trackEvent, useFlags } from "utils";

const ENROLLED_STATUSES: OfferStatusCode[] = ["ENROLLED", "ORDERED"];

export const useFeaturedOffers = () => {
  const keystone = useKeystone();
  const { shingleResealOffer, tingOffer } = useFlags();
  const { data } = usePolicyDetail();
  const { data: offers, isLoading, error } = usePolicyOffers();
  const [featuredOffers, setFeaturedOffers] = useState<
    KeystoneOfferEligibility[]
  >([]);

  useEffect(() => {
    if (!data?.userDetails.keystonePolicyId) {
      return;
    }

    const implementedOfferingNames: string[] = [];
    if (tingOffer) {
      implementedOfferingNames.push("ting-offer");
    }
    if (shingleResealOffer) {
      implementedOfferingNames.push("wind-defense");
    }

    if (error) {
      logException(error);
      trackEvent("Error fetching offers", { error });
    }

    const featuredOffers: KeystoneOfferEligibility[] =
      offers?.filter(
        (offer) =>
          offer.isEligible &&
          !ENROLLED_STATUSES.includes(offer?.offerStatusCode || "OFFERED") &&
          implementedOfferingNames.includes(offer.offeringInternalName),
      ) ?? [];

    setFeaturedOffers(featuredOffers);
    trackEvent("Featured Offers Loaded", {
      offers: offers?.map((offer) => offer.offeringInternalName),
    });
  }, [
    error,
    keystone,
    offers,
    shingleResealOffer,
    tingOffer,
    data?.userDetails.keystonePolicyId,
  ]);

  return { featuredOffers, isLoading, error };
};
